import { Box, Divider, Link, Typography } from '@mui/material'
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useTranslations } from 'next-intl'

import type { PopularRoute } from '@/src/types/destinationResult'

interface PopularRoutesProps {
    routes: PopularRoute[]
}

const PopularRoutes: React.FC<PopularRoutesProps> = ({ routes }) => {
    const t = useTranslations('destinationPage')
    return (
        <Box component="nav" aria-label="Popular flight routes" sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 2 }}>
                <FlightTakeoffIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                <Typography
                    component="h2"
                    variant="h6"
                    sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.1rem' } }}
                >
                    {t('popularRoutes')}
                </Typography>
            </Box>

            <Box component="ul" sx={{ border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden', listStyle: 'none', p: 0, m: 0 }}>
                {routes.map((route, i) => (
                    <Box component="li" key={route.routeSlug}>
                        <Link
                            href={route.url}
                            underline="none"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                px: { xs: 1.5, sm: 2 },
                                py: { xs: 1.25, sm: 1.5 },
                                color: 'text.primary',
                                '&:hover': { bgcolor: 'action.hover' },
                                transition: 'background-color 0.15s'
                            }}
                        >
                            <Typography variant="body2" sx={{ flex: 1 }}>
                                {t('flightsFrom', { city: route.originCity })}
                            </Typography>
                            <ArrowForwardIcon sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }} />
                        </Link>
                        {i < routes.length - 1 && <Divider />}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default PopularRoutes
export type { PopularRoutesProps }
